import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { AggridBanComponent } from '../../ban/aggrid-ban/aggrid-ban.component';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { DatePipe } from '@angular/common';
import { VenencfacService } from "../venservicios/venencfac.service";
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { VendetGuiaRemision } from "../veninterfaces/vendetGuiaRemision";
import { VenguiasService } from "../venservicios/venguias.service";

@Component({
  selector: 'app-venguias',
  templateUrl: './venguias.component.html',
  styleUrls: ['../../advantage/styles/saciwebmae.css']
})
export class VenguiasComponent implements OnInit {

  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  largo: string;
  allSelected: boolean;
  rowSelection = 'multiple';
  public frameworkComponents;
  arregloaEnviar: [VendetGuiaRemision[]];

  @Input() cliCodigo: string;
  @Input() indicadorGuia: number;
  @Input() orgfac:string
  @Input() encfacfecha:string
  @Input() DSNEBINGR:number
  
  @Output() detallesSeleccionados = new EventEmitter<[VendetGuiaRemision[]]>();
  @Output() signalSalir = new EventEmitter<boolean>();
  rowStyle;
  defaultColDef;
  
  columnDefsDetfac = [
    {
      headerName: '', field: 'SELECCIONADO', cellRendererFramework: AggridBanComponent, editable: false, width: 50
    },
    { // 0
      headerName: 'CÓDIGO', field: 'ENCGRE_CODIGO', width: 150, editable: false,
    },
    { // 1
      headerName: 'NUMERO', field: 'ENCGRE_NUMERO', editable: false, width: 150
 
    },
    { // 2
      headerName: 'Fec. Emisión', field: 'ENCGRE_FECHAEMISION', width: 200, editable: false
    },
    { // 3
      headerName: 'TRANSPORTISTA', field: 'ENCGRE_NMBRTRNSP', width: 200, editable: false
      // , editable: true,
    },
    { // 4
      headerName: 'CLIENTE', field: 'CLI_CODIGO', width: 60, editable: false
      // , editable: true,
    },
    {
      headerName: 'Nombre', field: 'NOMBRE', editable: false, width: 150,
    },
    { // 6
      headerName: 'TOTAL', field: 'ENCGRE_TOTAL', width: 100, editable: false
      // , editable: true,
    },
    { // 7
      headerName: 'FACTURA', field: 'ENCFAC_NUMERO', width: 90, editable: false
      // , editable: true,
    },

  ];

  constructor(public venguiasService:VenguiasService,private datePipe: DatePipe,private venencfacService:VenencfacService,
    private init: NuevoComponentService) {
      this.agTable();
     }
     agTable() {
      this.frameworkComponents = {
        cellPrueba: CellEditorPrueba
      };
      this.rowStyle = (params) => {
        if (params.node.rowIndex % 2 !== 0) {
          return {background: '#D6EAF8'};
        }
      };
      this.defaultColDef = {
        editable: true,
        width: 100,
        objeto: 'detpedgre'
      };
    }
  ngOnInit(): void {
    this.allSelected = false;
    this.largo = '400';
    this.arregloaEnviar = [[]];
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.cliCodigo !== undefined && this.orgfac === 'FAC') {
      let encpedetG
      this.venguiasService.getEncGreFac(this.cliCodigo, this.encfacfecha,this.DSNEBINGR).subscribe((res) => {
        this.venguiasService.encguia = res;
        this.venguiasService.encguia.map((encped) => {
          encpedetG = this.venencfacService.detfacarray[this.indicadorGuia].find(element => element.ENCGRE_NUMERO === encped.ENCGRE_CODIGO);
          if( encpedetG !== undefined){
            encped.SELECCIONADO = true;
            
          }else{
            encped.SELECCIONADO = false;
          }
          
          encped.ENCGRE_FECHAEMISION = this.datePipe.transform(encped.ENCGRE_FECHAEMISION, 'dd/MM/yyyy');
          //encped.ENCGRE_FECHAEMISION = this.datePipe.transform(encped.ENCGRE_FECHAEMISION, 'dd/MM/yyyy');
        });
      });
    }
  }
  seleccionar() {
    console.log(this.allSelected);
    if (this.allSelected === true) {
      this.venguiasService.encguia.map((encped) => {
        encped.SELECCIONADO = true;
      });
      this.aggrid.refreshaggrid(this.venguiasService.encguia, this.defaultColDef.objeto);
    } else if (this.allSelected === false) {
      this.venguiasService.encguia.map((encped) => {
        encped.SELECCIONADO = false;
      });
      this.aggrid.refreshaggrid(this.venguiasService.encguia, this.defaultColDef.objeto);
    }
  }
  enviarDetalles() {
    let encpedetG;
    this.venguiasService.encguia.map((encped) => {
      //if (this.venenguiaRemisionService.detguiaRemisionarray[this.indicadorGuia].length !== 0) {
       // encpedetG = this.venenguiaRemisionService.detguiaRemisionarray[this.indicadorGuia].find(element => element.ENCPED_NUMERO === encped.ENCPED_NUMERO);
      //}
      if (encped.SELECCIONADO === true ){//&& encpedetG === undefined) {
        this.venguiasService.getDetGuias(encped.ENCGRE_NUMERO).subscribe((res) => {
          this.arregloaEnviar.push(res);
          
        });
      }
    });
    setTimeout(() => {
      this.detallesSeleccionados.emit(this.arregloaEnviar);
    }, 1000);
  }
  enviarSalir() {
    this.signalSalir.emit(true);
  }
}
